import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet, apiPost, apiPut, apiRemove } from 'api-service';
import { magicNumbers, getEnv } from 'utils';

export const fetchCurrentUser = createAsyncThunk(
  'accountReducer/fetchCurrentUser',
  async (_, thunkAPI) => {
    try {
      const response = await apiGet('/user/user');
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const changeUserPassword = createAsyncThunk(
  'accountReducer/updateUserPassword',
  async (params, thunkAPI) => {
    try {
      const response = await apiPut('/user/password', params);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const hijackUser = createAsyncThunk(
  'accountReducer/hijackUser',
  async ({ userId }, thunkAPI) => {
    const { accountReducer } = thunkAPI.getState();
    const { department_id } = accountReducer.currentUser?.user;
    try {
      if (department_id !== magicNumbers.ROOT_USER_ID) {
        throw Error('PermissionError: account is not root');
      }
      const response = await apiPost('/user/hijack', {
        user_id: userId,
      });
      localStorage.removeItem(`hijack:${getEnv('REACT_APP_NAME')}`);
      localStorage.setItem('keyPrefix', 'hijack:');
      return {
        hijackedUser: response?.data,
        hijackerUser: accountReducer.currentUser,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateUserOnboardStatus = createAsyncThunk(
  'accountReducer/updateUserOnboardStatus',
  async (params, thunkAPI) => {
    const { accountReducer } = thunkAPI.getState();
    const userId = accountReducer.currentUser?.user.id;
    try {
      const response = await apiPost(
        `/user/${userId}/updateOnboardStatus`,
        params
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchCaptchaCode = createAsyncThunk(
  'accountReducer/getCaptchaCode',
  async (_, thunkAPI) => {
    try {
      const response = await apiGet('/user/captcha/api/flat');
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const changeAvatarImage = createAsyncThunk(
  'accountReducer/changeAvatarImage',
  async (params = {}, thunkAPI) => {
    const { accountReducer } = thunkAPI.getState();
    const userId = accountReducer.currentUser?.user.id;
    try {
      const response = await apiPost(
        `/user/avatars/${userId}?_method=put`,
        params?.formData
      );
      return response?.data?.result?.avatar;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addReceiverInfo = createAsyncThunk(
  'accountReducer/addReceiverInfo',
  async (params = {}, thunkAPI) => {
    try {
      const response = await apiPost('/user/receiver', params);
      return {
        data: response?.data?.result,
        isFromContact: !!params?.from_contact,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const verifyReceiverInfo = createAsyncThunk(
  'accountReducer/verifyReceiverInfo',
  async (params = {}, thunkAPI) => {
    try {
      const response = await apiPost('/user/receiver/verify', params);
      return response?.data?.result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const sendVerifyCode = createAsyncThunk(
  'accountReducer/sendVerifyCode',
  async (params = {}, thunkAPI) => {
    try {
      const response = await apiPost('/user/receiver/send-code', params);
      return response?.data?.result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const destroyReceiver = createAsyncThunk(
  'accountReducer/destroyReceiver',
  async (params = {}, thunkAPI) => {
    try {
      await apiRemove('/user/receiver/:id'.replace(':id', params?.id));
      return params?.id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
